/**
 * Product card “+” quick actions (see snippets/product-item.liquid modes).
 */
(function () {
  function routes() {
    return window.themeVariables && window.themeVariables.routes;
  }

  async function addVariantToCart(variantId) {
    const r = routes();
    if (!r || !variantId) return;

    const fd = new FormData();
    fd.append("id", String(variantId));
    fd.append("quantity", "1");
    fd.append("sections", "mini-cart");

    const response = await fetch(`${r.cartAddUrl}.js`, {
      method: "POST",
      body: fd,
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });

    const responseJson = await response.json().catch(() => ({}));

    if (response.ok) {
      const cartRes = await fetch(`${r.cartUrl}.js`);
      const cartContent = await cartRes.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: { cart: cartContent },
        })
      );
      if (responseJson.sections) {
        cartContent.sections = responseJson.sections;
      }
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: cartContent,
            openMiniCart:
              window.themeVariables &&
              window.themeVariables.settings &&
              window.themeVariables.settings.cartType === "drawer",
          },
        })
      );
    }

    document.documentElement.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response.ok ? "success" : "error",
          error: responseJson.description || responseJson.message || "",
        },
      })
    );
  }

  function getQuickPlusToggle(sheet) {
    if (!sheet) return null;
    const item = sheet.closest("product-item");
    const inTitle = item?.querySelector(".product-item__title-row .js-quick-plus-toggle");
    if (inTitle) return inTitle;
    const wrap = sheet.closest(".product-item__image-wrapper");
    return wrap?.querySelector(".js-quick-plus-toggle") || null;
  }

  function setSheetOpen(sheet, open) {
    if (!sheet) return;
    const toggle = getQuickPlusToggle(sheet);

    if (open) {
      document.querySelectorAll(".product-item__simple-sheet[data-open]").forEach((el) => {
        if (el !== sheet) {
          el.removeAttribute("data-open");
          getQuickPlusToggle(el)?.setAttribute("aria-expanded", "false");
        }
      });
      sheet.setAttribute("data-open", "");
      if (toggle) toggle.setAttribute("aria-expanded", "true");
    } else {
      sheet.removeAttribute("data-open");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    }
  }

  document.addEventListener(
    "click",
    async (e) => {
    const direct = e.target.closest(".js-quick-plus-direct");
    if (direct && direct.matches("button")) {
      e.preventDefault();
      e.stopPropagation();
      if (direct.disabled || direct.getAttribute("aria-busy") === "true") return;
      const vid = direct.getAttribute("data-variant-id");
      if (!vid) return;
      direct.setAttribute("aria-busy", "true");
      try {
        await addVariantToCart(vid);
      } finally {
        direct.removeAttribute("aria-busy");
      }
      return;
    }

    const chip = e.target.closest(".product-item__size-chip");
    if (chip && chip.matches("button") && !chip.disabled) {
      e.preventDefault();
      e.stopPropagation();
      const vid = chip.getAttribute("data-variant-id");
      if (!vid) return;
      chip.setAttribute("aria-busy", "true");
      try {
        await addVariantToCart(vid);
      } finally {
        chip.removeAttribute("aria-busy");
      }
      const sheet = chip.closest(".product-item__simple-sheet");
      setSheetOpen(sheet, false);
      return;
    }

    const toggle = e.target.closest(".js-quick-plus-toggle");
    if (toggle && toggle.matches("button")) {
      const sheetId = toggle.getAttribute("aria-controls");
      const sheet = sheetId && document.getElementById(sheetId);
      if (!sheet || !sheet.classList.contains("product-item__simple-sheet")) return;
      e.preventDefault();
      e.stopPropagation();
      const isOpen = sheet.hasAttribute("data-open");
      setSheetOpen(sheet, !isOpen);
      return;
    }

    const backdrop = e.target.closest(".product-item__simple-sheet__backdrop");
    if (backdrop) {
      const sheet = backdrop.closest(".product-item__simple-sheet");
      if (sheet && sheet.hasAttribute("data-open")) {
        e.preventDefault();
        setSheetOpen(sheet, false);
      }
    }
  },
    true
  );

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    document.querySelectorAll(".product-item__simple-sheet[data-open]").forEach((sheet) => {
      setSheetOpen(sheet, false);
    });
  });

  function applyColorToSheet(sheet, color) {
    if (!sheet || !color) return;
    sheet.setAttribute("data-active-color", color);
    sheet.querySelectorAll(".product-item__size-chip").forEach((chip) => {
      const chipColor = chip.getAttribute("data-color");
      if (chipColor === color) {
        chip.removeAttribute("hidden");
      } else {
        chip.setAttribute("hidden", "");
      }
    });
  }

  document.addEventListener("change", (e) => {
    const radio = e.target.closest(".product-item-meta__swatch-list .color-swatch__radio");
    if (!radio || !radio.checked) return;
    const item = radio.closest("product-item");
    if (!item) return;
    const sheet = item.querySelector(".product-item__simple-sheet--size-with-color");
    if (!sheet) return;
    applyColorToSheet(sheet, radio.value);
  });

  /* ------------------------------------------------------------------------
   * Product card: dual images — touch gallery (drag + snap) or quick swipe fallback
   * ------------------------------------------------------------------------ */
  const SWIPE_MIN_PX = 48;
  const MQ_MOUSE_ONLY = window.matchMedia("(pointer: fine) and (hover: hover) and (not (any-pointer: coarse)))");

  function prefersTouchGallery() {
    try {
      return !MQ_MOUSE_ONLY.matches;
    } catch (err) {
      return window.matchMedia("(pointer: coarse)").matches || window.matchMedia("(hover: none)").matches;
    }
  }

  let activeSwipe = null;
  let galleryDrag = null;

  function rubberTranslateT(rawT, w) {
    const min = -w;
    const max = 0;
    if (rawT < min) return min + (rawT - min) * 0.32;
    if (rawT > max) return max + (rawT - max) * 0.32;
    return rawT;
  }

  document.addEventListener(
    "touchstart",
    (e) => {
      if (e.touches.length !== 1) {
        activeSwipe = null;
        galleryDrag = null;
        return;
      }
      const link = e.target.closest(".product-item__image-wrapper--multiple .product-item__aspect-ratio");
      if (!link) {
        activeSwipe = null;
        galleryDrag = null;
        return;
      }
      if (link.closest(".we-product-collection-products, .featured-collections")) {
        activeSwipe = null;
        galleryDrag = null;
        return;
      }
      const track = link.querySelector(".product-item__image-track");
      const wrapper = link.closest(".product-item__image-wrapper--multiple");
      const t = e.touches[0];

      if (track && prefersTouchGallery()) {
        galleryDrag = {
          id: t.identifier,
          link,
          track,
          wrapper,
          sx: t.clientX,
          sy: t.clientY,
          ix: wrapper.classList.contains("product-item__image-wrapper--show-secondary") ? 1 : 0,
          axis: null,
          width: link.offsetWidth || 1,
        };
        activeSwipe = null;
        return;
      }

      galleryDrag = null;
      activeSwipe = {
        id: t.identifier,
        sx: t.clientX,
        sy: t.clientY,
        link,
      };
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    "touchmove",
    (e) => {
      if (!galleryDrag) return;
      const touch = Array.from(e.touches).find((x) => x.identifier === galleryDrag.id);
      if (!touch) return;

      const dx = touch.clientX - galleryDrag.sx;
      const dy = touch.clientY - galleryDrag.sy;

      if (!galleryDrag.axis) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
        galleryDrag.axis = Math.abs(dx) > Math.abs(dy) ? "h" : "v";
        if (galleryDrag.axis === "v") {
          galleryDrag = null;
          return;
        }
      }
      if (galleryDrag.axis !== "h") return;

      e.preventDefault();

      const w = galleryDrag.link.offsetWidth || galleryDrag.width || 1;
      galleryDrag.width = w;
      const rawT = -galleryDrag.ix * w + dx;
      const T = rubberTranslateT(rawT, w);
      galleryDrag.track.classList.add("is-we-dragging");
      galleryDrag.track.style.transform = `translate3d(${T}px, 0, 0)`;
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    "touchcancel",
    () => {
      if (galleryDrag) {
        galleryDrag.track.classList.remove("is-we-dragging");
        galleryDrag.track.style.transform = "";
        galleryDrag = null;
      }
      activeSwipe = null;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    "touchend",
    (e) => {
      if (galleryDrag) {
        const touch = Array.from(e.changedTouches).find((t) => t.identifier === galleryDrag.id);
        if (!touch) {
          galleryDrag.track.classList.remove("is-we-dragging");
          galleryDrag.track.style.transform = "";
          galleryDrag = null;
          return;
        }

        const g = galleryDrag;
        galleryDrag = null;

        const dx = touch.clientX - g.sx;
        const dy = touch.clientY - g.sy;
        const w = g.link.offsetWidth || g.width || 1;

        g.track.classList.remove("is-we-dragging");

        if (g.axis === "v") {
          g.track.style.transform = "";
          return;
        }

        if (!g.axis) {
          if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy)) {
            g.track.style.transform = "";
            return;
          }
        }

        const releaseT = -g.ix * w + dx;
        const nextIx = releaseT > -w * 0.5 ? 0 : 1;

        if (nextIx === 1) g.wrapper.classList.add("product-item__image-wrapper--show-secondary");
        else g.wrapper.classList.remove("product-item__image-wrapper--show-secondary");

        g.track.style.transform = "";

        const movedHoriz = g.axis === "h" && (Math.abs(dx) > 10 || Math.abs(releaseT + g.ix * w) > 4);
        const flick = !g.axis && Math.abs(dx) >= SWIPE_MIN_PX && Math.abs(dx) >= Math.abs(dy);
        if (movedHoriz || flick) {
          g.link.dataset.suppressImageNavClick = "1";
          window.setTimeout(() => {
            delete g.link.dataset.suppressImageNavClick;
          }, 450);
          if (nextIx !== g.ix || flick) e.preventDefault();
        }
        return;
      }

      if (!activeSwipe) return;
      const touch = Array.from(e.changedTouches).find((t) => t.identifier === activeSwipe.id);
      if (!touch) {
        activeSwipe = null;
        return;
      }

      const { link, sx, sy } = activeSwipe;
      activeSwipe = null;

      const dx = touch.clientX - sx;
      const dy = touch.clientY - sy;
      if (Math.abs(dx) < SWIPE_MIN_PX || Math.abs(dx) < Math.abs(dy)) return;

      const wrapper = link.closest(".product-item__image-wrapper--multiple");
      if (!wrapper) return;

      const rtl = document.documentElement.getAttribute("dir") === "rtl";
      const towardSecondary = rtl ? dx > SWIPE_MIN_PX : dx < -SWIPE_MIN_PX;
      const towardPrimary = rtl ? dx < -SWIPE_MIN_PX : dx > SWIPE_MIN_PX;

      if (towardSecondary) wrapper.classList.add("product-item__image-wrapper--show-secondary");
      else if (towardPrimary) wrapper.classList.remove("product-item__image-wrapper--show-secondary");
      else return;

      e.preventDefault();
      link.dataset.suppressImageNavClick = "1";
      window.setTimeout(() => {
        delete link.dataset.suppressImageNavClick;
      }, 450);
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    "click",
    (e) => {
      const link = e.target.closest(".product-item__image-wrapper--multiple .product-item__aspect-ratio");
      if (link && link.dataset.suppressImageNavClick) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }
      }
    },
    true
  );
})();

/**
 * Shop the look: inline variant dropdown price updates.
 */
(function () {
  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
        style: "currency",
        currency: (window.themeVariables && window.themeVariables.shop && window.themeVariables.shop.currency) || "EUR",
      }).format(cents / 100);
    } catch (err) {
      return `${(cents / 100).toFixed(2)} €`;
    }
  }

  document.addEventListener("change", (event) => {
    const select = event.target;
    if (!select?.classList?.contains("shop-the-look__variant-select")) return;

    const option = select.selectedOptions && select.selectedOptions[0];
    const scope = select.closest(".shop-the-look__product, quick-buy-popover");
    const priceEl = scope?.querySelector("[data-shop-the-look-price]");
    const price = parseInt(option?.dataset.price || "0", 10);

    if (priceEl && Number.isFinite(price)) {
      priceEl.textContent = formatMoney(price);
    }
  });
})();

/**
 * Collection grid promos: sync row height to tallest product card.
 */
(function () {
  const GRID_SELECTOR = "#ProductsList.products-list__inner";
  const CARD_SELECTOR = ".product-item";
  let resizeObserver = null;
  let scheduled = false;

  function syncGridRowHeight() {
    scheduled = false;
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    const cards = grid.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) {
      grid.style.removeProperty("--we-grid-row-height");
      return;
    }

    let maxHeight = 0;
    cards.forEach((card) => {
      const height = card.getBoundingClientRect().height;
      if (height > maxHeight) maxHeight = height;
    });

    if (maxHeight > 0) {
      grid.style.setProperty("--we-grid-row-height", `${Math.ceil(maxHeight)}px`);
    }
  }

  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(syncGridRowHeight);
  }

  function bindGrid(grid) {
    if (!grid) return;

    if (typeof ResizeObserver !== "undefined") {
      if (!resizeObserver) {
        resizeObserver = new ResizeObserver(scheduleSync);
      }
      resizeObserver.observe(grid);
      grid.querySelectorAll(CARD_SELECTOR).forEach((card) => resizeObserver.observe(card));
    }

    if (grid.dataset.weGridRowHeightBound !== "1") {
      grid.dataset.weGridRowHeightBound = "1";
      window.addEventListener("resize", scheduleSync, { passive: true });
    }

    scheduleSync();
  }

  function init() {
    document.querySelectorAll(GRID_SELECTOR).forEach(bindGrid);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const grid = event.target.querySelector(GRID_SELECTOR);
    if (grid) bindGrid(grid);
  });

  document.addEventListener("pagination:page-changed", () => {
    window.setTimeout(init, 100);
  });

  document.addEventListener("facet:criteria-changed", () => {
    window.setTimeout(init, 100);
  });

  const facetMain = document.getElementById("facet-main");
  if (facetMain && typeof MutationObserver !== "undefined") {
    const facetObserver = new MutationObserver(() => {
      init();
    });
    facetObserver.observe(facetMain, { childList: true, subtree: true });
  }
})();

/**
 * Product page: desktop shows all media full-size (stacked), not thumbnail strip.
 */
(function () {
  const DESKTOP_MQ = window.matchMedia("(min-width: 1000px)");
  const STACKED_CLASS = "we-product-media__list--stacked";
  const MEDIA_SELECTOR = "product-media.we-product-media--stacked-desktop";

  async function enableStackedDesktop(media) {
    const carousel = media.querySelector("flickity-carousel.product__media-list");
    if (!carousel) return;
    if (!DESKTOP_MQ.matches) return;

    carousel.classList.add(STACKED_CLASS);
    media.classList.add("is-we-stacked-desktop");

    if (carousel.childElementCount <= 1) return;

    try {
      const flickityInstance = await carousel.flickityInstance;
      if (flickityInstance) {
        flickityInstance.destroy();
      }
    } catch (error) {
      /* flickity may not be ready */
    }
  }

  async function disableStackedDesktop(media) {
    const carousel = media.querySelector("flickity-carousel.product__media-list");
    if (!carousel) return;

    carousel.classList.remove(STACKED_CLASS);
    media.classList.remove("is-we-stacked-desktop");

    if (!DESKTOP_MQ.matches && !carousel.classList.contains("flickity-enabled")) {
      try {
        await carousel.reload();
      } catch (error) {
        /* ignore */
      }
    }
  }

  async function syncProductMediaLayout(media) {
    if (DESKTOP_MQ.matches) {
      await enableStackedDesktop(media);
    } else {
      await disableStackedDesktop(media);
    }
  }

  function getVariantMediaId(media, variant) {
    if (variant?.featured_media?.id) {
      return variant.featured_media.id;
    }

    const firstVisible = media.querySelector(".product__media-item:not(.is-filtered)[data-media-id]");
    return firstVisible ? parseInt(firstVisible.getAttribute("data-media-id"), 10) : null;
  }

  function setVariantMediaFirst(media, slide) {
    media.querySelectorAll(".product__media-item.we-product-media__item--variant-first").forEach((item) => {
      item.classList.remove("we-product-media__item--variant-first");
    });

    slide.classList.add("we-product-media__item--variant-first");
  }

  function scrollToMediaTop(media) {
    const mediaTop = media.getBoundingClientRect().top + window.scrollY;
    const stickyOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"), 10) || 0;

    window.scrollTo({
      top: Math.max(mediaTop - stickyOffset, 0),
      behavior: "smooth",
    });
  }

  async function showVariantMedia(media, variant) {
    const mediaId = getVariantMediaId(media, variant);
    let slide = mediaId
      ? media.querySelector(`.product__media-item[data-media-id="${mediaId}"]:not(.is-filtered)`)
      : null;

    if (!slide) {
      slide = media.querySelector(".product__media-item:not(.is-filtered)[data-media-id]");
    }
    if (!slide) return;

    const carousel = media.querySelector("flickity-carousel.product__media-list");
    const isStacked = DESKTOP_MQ.matches && media.classList.contains("is-we-stacked-desktop");

    if (isStacked) {
      setVariantMediaFirst(media, slide);
      scrollToMediaTop(media);
      return;
    }

    if (carousel) {
      try {
        const flickityInstance = await carousel.flickityInstance;
        if (flickityInstance?.selectCell) {
          flickityInstance.selectCell(slide);
          return;
        }
      } catch (error) {
        /* flickity may not be ready */
      }
    }

    slide.scrollIntoView({ behavior: "smooth", block: "nearest" });
  }

  function bindProductMedia(media) {
    if (!media || media.dataset.weStackedDesktopBound === "1") return;
    media.dataset.weStackedDesktopBound = "1";

    const carousel = media.querySelector("flickity-carousel.product__media-list");
    if (!carousel) return;

    carousel.addEventListener("flickity:ready", () => {
      if (DESKTOP_MQ.matches) {
        enableStackedDesktop(media);
      }
    });

    const formId = media.getAttribute("form-id");
    const form = formId ? document.getElementById(formId) : null;
    form?.addEventListener("variant:change", (event) => {
      const variant = event.detail?.variant;
      const carousel = media.querySelector("flickity-carousel.product__media-list");
      const goToVariantMedia = () => showVariantMedia(media, variant);

      window.setTimeout(async () => {
        await syncProductMediaLayout(media);
        await goToVariantMedia();
      }, 100);

      if (carousel) {
        carousel.addEventListener("flickity:ready", goToVariantMedia, { once: true });
      }
    });

    syncProductMediaLayout(media);
  }

  function initProductMedia() {
    document.querySelectorAll(MEDIA_SELECTOR).forEach(bindProductMedia);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductMedia);
  } else {
    initProductMedia();
  }

  DESKTOP_MQ.addEventListener("change", () => {
    document.querySelectorAll(MEDIA_SELECTOR).forEach(syncProductMediaLayout);
  });

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll(MEDIA_SELECTOR).forEach((media) => {
      delete media.dataset.weStackedDesktopBound;
      bindProductMedia(media);
    });
  });
})();

/**
 * Product page: per-image zoom + PhotoSwipe / openable-element sync.
 *
 * Fail-safe cleanup: when the [open] attribute is removed from <product-image-zoom>
 * (i.e. PhotoSwipe has signaled close OR the user dismissed via focus trap),
 * we wait until PhotoSwipe's hide animation has had time to finish and then
 * strip any leftover `pswp--*` classes/inline styles that would otherwise
 * leave the full-screen overlay sitting invisibly on top of the page
 * (causing the "+" cursor over the thumbnail and unclickable accordions).
 */
(function () {
  const PSWP_LEFTOVER_CLASSES = [
    "pswp--open",
    "pswp--visible",
    "pswp--animate_opacity",
    "pswp--animated-in",
    "pswp--zoom-allowed",
    "pswp--zoomed-in",
    "pswp--touch",
    "pswp--notouch",
    "pswp--css_animation",
    "pswp--svg",
    "pswp--ie",
    "pswp--dragging",
  ];

  function forceCleanupZoom(zoom) {
    if (zoom.hasAttribute("open")) return;
    PSWP_LEFTOVER_CLASSES.forEach((c) => zoom.classList.remove(c));
    zoom.removeAttribute("style");
    zoom.removeAttribute("aria-hidden");
    zoom.querySelector(".pswp__bg")?.removeAttribute("style");
    zoom.querySelector(".pswp__container")?.removeAttribute("style");
  }

  function bindProductImageZoom(zoom) {
    if (!zoom || zoom.dataset.weZoomSync === "1") return;
    zoom.dataset.weZoomSync = "1";

    const observer = new MutationObserver(() => {
      if (zoom.hasAttribute("open")) return;
      // Wait long enough for PhotoSwipe's own close animation + destroy to run,
      // then force-clean anything PS left behind.
      window.setTimeout(() => forceCleanupZoom(zoom), 450);
      window.setTimeout(() => forceCleanupZoom(zoom), 900);
    });
    observer.observe(zoom, { attributes: true, attributeFilter: ["open"] });
  }

  function initProductImageZoom() {
    document.querySelectorAll("product-image-zoom").forEach(bindProductImageZoom);
  }

  // Capture-phase click: set is-selected on the correct image BEFORE
  // toggle-button opens the zoom element, so PhotoSwipe starts at the right slide.
  document.addEventListener(
    "click",
    (event) => {
      const button = event.target.closest(".we-product__zoom-button--per-image");
      if (!button) return;

      const mediaItem = button.closest(".product__media-item");
      const productMedia = button.closest(".product__media");
      if (!mediaItem || !productMedia) return;

      productMedia.querySelectorAll(".product__media-item").forEach((item) => {
        item.classList.remove("is-selected");
      });
      mediaItem.classList.add("is-selected");
    },
    true
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initProductImageZoom);
  } else {
    initProductImageZoom();
  }

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("product-image-zoom").forEach(bindProductImageZoom);
  });
})();

/**
 * Product page: full-outfit block (see snippets/we-full-outfit.liquid).
 *
 * Bundles the checked products into a single /cart/add.js request.
 */
(function () {
  function routes() {
    return window.themeVariables && window.themeVariables.routes;
  }

  function formatMoney(amountCents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(amountCents);
    }
    const value = (amountCents / 100).toFixed(2);
    return `${value} \u20AC`;
  }

  function getCheckboxes(root) {
    return Array.from(root.querySelectorAll(".we-full-outfit__checkbox"));
  }

  function updateState(root) {
    const checkboxes = getCheckboxes(root);
    const button = root.querySelector("[data-we-full-outfit-add]");

    let total = 0;
    let selectedCount = 0;
    checkboxes.forEach((cb) => {
      const row = cb.closest(".we-full-outfit__row");
      const selectedVariantOption = row?.querySelector(".we-full-outfit__variant-select")?.selectedOptions?.[0];

      if (selectedVariantOption && selectedVariantOption.dataset.available !== "true") {
        cb.checked = false;
        cb.disabled = true;
        row.closest(".we-full-outfit__item")?.classList.add("we-full-outfit__item--sold-out");
        const badge = row.querySelector("[data-we-full-outfit-badge]");
        if (badge) {
          badge.hidden = false;
        }
      } else if (selectedVariantOption) {
        cb.disabled = false;
        cb.dataset.variantId = selectedVariantOption.value;
        cb.dataset.price = selectedVariantOption.dataset.price || "0";
        row.closest(".we-full-outfit__item")?.classList.remove("we-full-outfit__item--sold-out");
        const badge = row.querySelector("[data-we-full-outfit-badge]");
        if (badge) {
          badge.hidden = true;
        }
      }

      if (cb.disabled) return;
      if (!cb.checked) return;
      selectedCount += 1;
      const price = parseInt(selectedVariantOption?.dataset.price || cb.dataset.price || "0", 10);
      if (Number.isFinite(price)) total += price;
    });

    if (button) {
      const baseLabel = button.dataset.label || button.textContent.trim();
      const itemLabel = selectedCount === 1 ? "Artikel" : "Artikel";
      button.textContent = `${baseLabel} (${selectedCount} ${itemLabel}) — ${formatMoney(total)}`;
      button.disabled = selectedCount === 0;
    }
  }

  function updateRowVariant(root, select) {
    const row = select.closest(".we-full-outfit__row");
    const checkbox = row?.querySelector(".we-full-outfit__checkbox");
    const option = select.selectedOptions && select.selectedOptions[0];
    if (!row || !checkbox || !option) return;

    const available = option.dataset.available === "true";
    const price = parseInt(option.dataset.price || "0", 10);
    const comparePrice = parseInt(option.dataset.comparePrice || "0", 10);
    const priceEl = row.querySelector("[data-we-full-outfit-price]");
    const comparePriceEl = row.querySelector("[data-we-full-outfit-compare-price]");
    const badge = row.querySelector("[data-we-full-outfit-badge]");
    const item = row.closest(".we-full-outfit__item");

    checkbox.dataset.variantId = option.value;
    checkbox.dataset.price = String(Number.isFinite(price) ? price : 0);
    checkbox.disabled = !available;
    if (!available) {
      checkbox.checked = false;
    }

    if (priceEl) {
      priceEl.textContent = formatMoney(Number.isFinite(price) ? price : 0);
      priceEl.classList.toggle("we-full-outfit__price--sale", comparePrice > price);
    }
    if (comparePriceEl) {
      comparePriceEl.hidden = !(comparePrice > price);
      comparePriceEl.textContent = comparePrice > price ? formatMoney(comparePrice) : "";
    }
    if (badge) {
      badge.hidden = available;
    }
    item?.classList.toggle("we-full-outfit__item--sold-out", !available);

    updateState(root);
  }

  async function addOutfitToCart(root) {
    const r = routes();
    if (!r) return;

    const button = root.querySelector("[data-we-full-outfit-add]");
    if (!button || button.disabled) return;

    const items = getCheckboxes(root)
      .filter((cb) => !cb.disabled && cb.checked && cb.dataset.variantId)
      .map((cb) => {
        const row = cb.closest(".we-full-outfit__row");
        const selectedVariantOption = row?.querySelector(".we-full-outfit__variant-select")?.selectedOptions?.[0];
        return {
          id: parseInt(selectedVariantOption?.value || cb.dataset.variantId, 10),
          quantity: 1,
        };
      })
      .filter((item) => Number.isFinite(item.id));

    if (items.length === 0) return;

    button.setAttribute("aria-busy", "true");
    button.disabled = true;

    try {
      const response = await fetch(`${r.cartAddUrl}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items, sections: "mini-cart" }),
      });

      const responseJson = await response.json().catch(() => ({}));

      if (response.ok) {
        const cartRes = await fetch(`${r.cartUrl}.js`);
        const cartContent = await cartRes.json();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cartContent } })
        );
        if (responseJson.sections) {
          cartContent.sections = responseJson.sections;
        }
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart:
                window.themeVariables &&
                window.themeVariables.settings &&
                window.themeVariables.settings.cartType === "drawer",
            },
          })
        );
      }

      document.documentElement.dispatchEvent(
        new CustomEvent("cart-notification:show", {
          bubbles: true,
          cancelable: true,
          detail: {
            status: response.ok ? "success" : "error",
            error: responseJson.description || responseJson.message || "",
          },
        })
      );
    } finally {
      button.removeAttribute("aria-busy");
      updateState(root);
    }
  }

  function bindOutfit(root) {
    if (!root || root.dataset.weFullOutfitBound === "1") return;
    root.dataset.weFullOutfitBound = "1";

    root.addEventListener("change", (event) => {
      if (event.target.classList?.contains("we-full-outfit__checkbox")) {
        updateState(root);
      } else if (event.target.classList?.contains("we-full-outfit__variant-select")) {
        updateRowVariant(root, event.target);
      }
    });

    root.addEventListener("click", (event) => {
      const button = event.target.closest("[data-we-full-outfit-add]");
      if (button) {
        event.preventDefault();
        addOutfitToCart(root);
        return;
      }

      if (event.target.closest(".we-full-outfit__media")) return;
      if (event.target.closest(".we-full-outfit__variant-select-wrapper")) return;

      const row = event.target.closest(".we-full-outfit__row");
      if (!row || !root.contains(row)) return;

      const checkbox = row.querySelector(".we-full-outfit__checkbox");
      if (!checkbox || checkbox.disabled) return;
      const selectedVariantOption = row.querySelector(".we-full-outfit__variant-select")?.selectedOptions?.[0];
      if (selectedVariantOption && selectedVariantOption.dataset.available !== "true") return;
      if (event.target === checkbox) return;

      event.preventDefault();
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event("change", { bubbles: true }));
    });

    updateState(root);
  }

  function initOutfit() {
    document.querySelectorAll("we-full-outfit").forEach(bindOutfit);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOutfit);
  } else {
    initOutfit();
  }

  document.addEventListener("shopify:section:load", (event) => {
    event.target.querySelectorAll("we-full-outfit").forEach((node) => {
      delete node.dataset.weFullOutfitBound;
      bindOutfit(node);
    });
  });
})();

/**
 * Product page: bundle block (see snippets/we-bundle.liquid).
 *
 * When a <we-bundle> exists inside the main product form's section, the
 * normal add-to-cart submit is intercepted and replaced with a single
 * /cart/add.js request that contains the main product + all bundle items.
 * We then dispatch the same events the theme's ProductForm would, so the
 * mini-cart / notification UI updates exactly once.
 */
(function () {
  function routes() {
    return window.themeVariables && window.themeVariables.routes;
  }

  function settings() {
    return (window.themeVariables && window.themeVariables.settings) || {};
  }

  function getMainQuantity(form) {
    const formData = new FormData(form);
    const qtyFromFormData = parseInt(formData.get("quantity") || "", 10);
    if (Number.isFinite(qtyFromFormData) && qtyFromFormData > 0) {
      return qtyFromFormData;
    }

    const quantityField =
      form.querySelector('[name="quantity"]') ||
      (form.id ? document.querySelector(`[form="${form.id}"][name="quantity"]`) : null);
    const qtyFromField = parseInt(quantityField && quantityField.value, 10);

    return Number.isFinite(qtyFromField) && qtyFromField > 0 ? qtyFromField : 1;
  }

  function getBundleItems(form, quantity) {
    const section = form.closest(".shopify-section, [data-section-id]") || document;
    const bundles = section.querySelectorAll("we-bundle[data-include]");
    const items = [];
    bundles.forEach((bundle) => {
      bundle.querySelectorAll("[data-we-bundle-row]").forEach((row) => {
        if (row.dataset.available === "false") return;
        const select = row.querySelector(".we-bundle__variant-select");
        const option = select && select.selectedOptions && select.selectedOptions[0];
        if (option && option.dataset.available === "false") return;
        const rawId = option ? option.value : row.dataset.variantId;
        const id = parseInt(rawId, 10);
        if (!Number.isFinite(id)) return;
        items.push({ id, quantity, properties: { _bundle: "true" } });
      });
    });
    return items;
  }

  async function submitWithBundle(form, bundleItems, mainQty) {
    const r = routes();
    if (!r) return;

    const formData = new FormData(form);
    const mainId = parseInt(formData.get("id"), 10);
    if (!Number.isFinite(mainId)) return;

    const items = [{ id: mainId, quantity: mainQty }];
    const properties = {};
    formData.forEach((value, key) => {
      const match = /^properties\[(.+)\]$/.exec(key);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length > 0) {
      items[0].properties = properties;
    }
    bundleItems.forEach((item) => items.push(item));

    const submitButtons = Array.from(form.elements).filter((el) => el.type === "submit");
    submitButtons.forEach((btn) => {
      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-busy", "true");
    });

    let response;
    let responseJson = {};
    try {
      response = await fetch(`${r.cartAddUrl}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ items, sections: ["mini-cart"] }),
      });
      responseJson = await response.json().catch(() => ({}));
    } finally {
      submitButtons.forEach((btn) => {
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-busy");
      });
    }

    if (response && response.ok) {
      const cfg = settings();
      if (cfg.cartType === "page" || cfg.pageType === "cart") {
        window.location.href = `${(window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/"}cart`;
        return;
      }

      form.dispatchEvent(
        new CustomEvent("variant:added", {
          bubbles: true,
          detail: { variant: (responseJson.items && responseJson.items[0]) || responseJson },
        })
      );

      try {
        const cartRes = await fetch(`${r.cartUrl}.js`);
        const cartContent = await cartRes.json();
        cartContent.sections = responseJson.sections;
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:updated", { bubbles: true, detail: { cart: cartContent } })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
            detail: {
              cart: cartContent,
              openMiniCart: cfg.cartType === "drawer" && form.closest(".drawer") === null,
            },
          })
        );
      } catch (err) {
        form.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      }
    } else {
      form.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    }

    form.dispatchEvent(
      new CustomEvent("cart-notification:show", {
        bubbles: true,
        cancelable: true,
        detail: {
          status: response && response.ok ? "success" : "error",
          error: responseJson.description || responseJson.message || "",
        },
      })
    );
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "de-DE", {
        style: "currency",
        currency: (window.themeVariables && window.themeVariables.shop && window.themeVariables.shop.currency) || "EUR",
      }).format(cents / 100);
    } catch (err) {
      return `${(cents / 100).toFixed(2)} €`;
    }
  }

  function updateBundleRow(select) {
    const row = select.closest("[data-we-bundle-row]");
    const option = select.selectedOptions && select.selectedOptions[0];
    if (!row || !option) return;

    const available = option.dataset.available === "true";
    const price = parseInt(option.dataset.price || "0", 10);
    const comparePrice = parseInt(option.dataset.comparePrice || "0", 10);
    const priceEl = row.querySelector("[data-we-bundle-price]");
    const comparePriceEl = row.querySelector("[data-we-bundle-compare-price]");
    const badge = row.querySelector("[data-we-bundle-badge]");

    row.dataset.variantId = option.value;
    row.dataset.available = available ? "true" : "false";
    row.classList.toggle("we-bundle__item--sold-out", !available);

    if (priceEl) {
      priceEl.textContent = formatMoney(Number.isFinite(price) ? price : 0);
      priceEl.classList.toggle("we-bundle__price--sale", comparePrice > price);
    }
    if (comparePriceEl) {
      if (comparePrice > price) {
        comparePriceEl.textContent = formatMoney(comparePrice);
        comparePriceEl.hidden = false;
      } else {
        comparePriceEl.hidden = true;
      }
    }
    if (badge) {
      badge.hidden = available;
    }
  }

  document.addEventListener("change", (event) => {
    const select = event.target;
    if (!select || !select.classList || !select.classList.contains("we-bundle__variant-select")) return;
    updateBundleRow(select);
  });

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!form || !(form instanceof HTMLFormElement)) return;
      if (form.getAttribute("is") !== "product-form") return;
      if (form.dataset.weBundleHandling === "1") return;

      const mainQty = getMainQuantity(form);
      const bundleItems = getBundleItems(form, mainQty);
      if (bundleItems.length === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      form.dataset.weBundleHandling = "1";
      submitWithBundle(form, bundleItems, mainQty).finally(() => {
        delete form.dataset.weBundleHandling;
      });
    },
    { capture: true }
  );
})();

/* Shop the look: dynamically pick which side the inline product card opens on
   based on the available space inside the image wrapper. This prevents cards
   anchored near an edge from rendering off-screen. */
(function () {
  const SAFE_GAP = 12;

  function findAnchor(product) {
    const wrapper = product.parentElement;
    if (wrapper && wrapper.classList && wrapper.classList.contains("shop-the-look__product-wrapper")) {
      return wrapper;
    }
    return product.closest(".shop-the-look__product-wrapper") || product;
  }

  function findImageBox(product) {
    const item = product.closest("shop-the-look-item") || product.closest(".shop-the-look__item");
    if (!item) return null;
    return (
      item.querySelector(".shop-the-look__image-wrapper") ||
      item.querySelector(".shop-the-look__image") ||
      item
    );
  }

  function viewportBox() {
    return {
      left: 0,
      right: window.innerWidth || document.documentElement.clientWidth,
    };
  }

  function pickSide(product) {
    const anchor = findAnchor(product);
    const imageBox = findImageBox(product);
    if (!anchor) return null;

    const anchorRect = anchor.getBoundingClientRect();
    const imageRect = imageBox ? imageBox.getBoundingClientRect() : null;
    const vp = viewportBox();

    const leftBound = imageRect ? Math.max(imageRect.left, vp.left) : vp.left;
    const rightBound = imageRect ? Math.min(imageRect.right, vp.right) : vp.right;

    const cardWidth = product.offsetWidth || product.getBoundingClientRect().width || 280;

    const spaceRight = rightBound - anchorRect.right;
    const spaceLeft = anchorRect.left - leftBound;

    const fitsRight = spaceRight >= cardWidth + SAFE_GAP;
    const fitsLeft = spaceLeft >= cardWidth + SAFE_GAP;

    if (fitsRight && !fitsLeft) return "right";
    if (fitsLeft && !fitsRight) return "left";
    if (fitsRight && fitsLeft) return spaceRight >= spaceLeft ? "right" : "left";
    return spaceRight >= spaceLeft ? "right" : "left";
  }

  function applySide(product) {
    if (!product || !product.isConnected) return;
    const side = pickSide(product);
    if (!side) return;
    if (product.dataset.side !== side) {
      product.dataset.side = side;
    }
  }

  document.addEventListener("openable-element:open", (event) => {
    const target = event.target;
    if (!target || !target.classList || !target.classList.contains("shop-the-look__product")) return;
    requestAnimationFrame(() => applySide(target));
  });

  let resizeRaf = 0;
  window.addEventListener("resize", () => {
    if (resizeRaf) return;
    resizeRaf = requestAnimationFrame(() => {
      resizeRaf = 0;
      document.querySelectorAll(".shop-the-look__product[open]").forEach(applySide);
    });
  });
})();

/**
 * Block checkout when minimum order value is not met (cart page + drawer).
 */
(function () {
  function isCheckoutBlocked(form) {
    const button = form.querySelector('[name="checkout"]');
    return button && button.disabled && button.getAttribute("aria-disabled") === "true";
  }

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.id !== "mini-cart-form" && !form.querySelector(".cart__checkout-button")) return;
      if (!isCheckoutBlocked(form)) return;
      event.preventDefault();
    },
    true
  );
})();
